import styled from '@emotion/styled'
import { FIELD_HEIGHT } from '../schema-item'

export const Container = styled.div`
  height: ${FIELD_HEIGHT}px;
  width: 100%;
  background-color: #faf9ff;
  box-shadow: 0px 3px 10px 0px #24018a26;
  border-radius: 4px;
  padding: 5px;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 4px;
    width: 4px;
    height: 90%;
    background: #7f52ff;
    border-radius: 10px;
  }
`
